import { stockTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('indent_form')
export class IndentForm {
    @PrimaryGeneratedColumn('increment', {
        name: 'indent_form_id',
    })
    indentFormId: number;

    @Column('varchar',{
        nullable: false,
        name:'indent_number'
    })
    indentNumber:string;

    @Column('datetime', {
        nullable: false,
        name: 'indent_date',
    })
    indentDate: Date;
    
    @Column({
        type: 'enum',
        enum: stockTypeEnum,
        nullable: false,
        name: 'stock_type',
        default:"SaleOrder",
    })
    stockType:stockTypeEnum;

    @Column('int', {
        nullable: false,
        name: 'sale_order_id',
    })
    saleOrderId: number;
    @Column('int', {
        nullable: false,
        name: 'sale_order_item_id',
    })
    saleOrderItemId: number;

    @Column('int', {
        nullable: false,
        name: 'item_id',
    })
    itemId: number;

    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "quantity",
        default: 0,
    })
    quantity: number;

    @Column('int', {
        nullable: false,
        name: 'unit_id',
        default: 0
    })
    unitId: number;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

   
}